import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import List from '@zenbusiness/zui/List';
import { superstyled } from '@zenbusiness/zui/styles';

export const FaqList = superstyled({
  tag: List,
  name: 'FaqItem',
  slot: 'FaqList',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 3),
    gap: theme.spacing(1),
    listStyle: 'disc',
  }),
});

export const ExpandIcon = superstyled({
  tag: ExpandMoreIcon,
  name: 'FaqItem',
  slot: 'ExpandIcon',
  styles: {
    width: 24,
    height: 24,
  },
});
